<!--
    HomePage.vue
    Core of the SPA. Asks a series of statistical questions to narrow down list
    by Guy E. White <guw968@g.harvard.edu>
-->

<template>
    <div>
        <show-welcome></show-welcome>
        <div class="container">
            <show-popular :tests='tests'></show-popular>
            <show-advert></show-advert>
        </div>
        <show-footer></show-footer>
    </div>
</template>

<script>
import ShowWelcome from '@/components/ShowWelcome.vue';
import ShowPopular from '@/components/ShowPopular.vue';
import ShowAdvert from '@/components/ShowAdvert.vue';
import ShowFooter from '@/components/ShowFooter.vue';
import * as app from '@/common/app.js';
export default {
    name: 'ShowHome',
    components: {
        'show-welcome': ShowWelcome,
        'show-popular': ShowPopular,
        'show-advert': ShowAdvert,
        'show-footer': ShowFooter
    },
    data: function() {
        return {
            tests: []
        };
    },
    mounted: function() {
        app.api.limit('tests', 'hitCount', 'desc', 3).then(response => {
            this.tests = response;
        });
    }
};
</script>

<style scoped>
</style>
